import { Outlet, useLocation } from 'react-router-dom';
import { ActivitiesList } from './components/ActivitiesList';

/**
 * 活动模块路由壳
 */
export default function ActivitiesPageShell() {
  const location = useLocation();
  const isActivitiesRoot = location.pathname === '/activities';

  return (
    <div className="h-full min-h-0 w-full flex overflow-hidden bg-background">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        {/** 子页面必须处于 flex-1 + min-h-0 容器内，否则编辑器等内部滚动 / 底部栏高度链断裂 */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {isActivitiesRoot ? <ActivitiesList /> : <Outlet />}
        </div>
      </div>
    </div>
  );
}
